import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App.jsx';
import AdminPage from './pages/AdminPage.jsx';
import './index.css';

// BrowserRouter gives clean URLs (e.g. /admin instead of /#/admin).
// This requires a host-level rewrite so that deep links and refreshes
// resolve to index.html and let React Router take over client-side.
// This app is hosted on AWS Amplify, so that rewrite is configured in the
// Amplify Console under App settings -> Rewrites and redirects, not in a
// repo file: 404/403 -> /index.html (200), matching all paths except /admin
// which is routed here directly.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
